/* =============================================================================
   CART UPSELL + Dr Free Gift refresh | BY CLICKMOUSE
   Horizon 4.x-native. The upsell card is server-rendered by cart-upsell-block.liquid
   (via cart-summary.liquid) and re-renders with the cart section on every morph, so
   there is NO DOM injection and NO cart-event listener here. This file does two things:
     1. Handle the ADD click (delegated on document, survives every morph).
     2. Expose window.refreshCart for Dr Free Gift's no-reload hook.
   The upsell-only guard is server-rendered in cart-summary.liquid and the remove-button
   lock is server-rendered in cart-products.liquid — neither is done in JS.
   ============================================================================= */

(function () {
  function triggerCartRefresh() {
    const cartLinesUpdate = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    cartLinesUpdate.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(cartLinesUpdate);
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); // legacy, harmless
  }

  // Dr Free Gift calls this instead of reloading after awarding a gift.
  window.refreshCart = triggerCartRefresh;

  document.addEventListener('click', async function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const btn = target && target.closest('.auspsfc-cart-upsell-widget__add-btn');
    if (!btn) return;
    event.preventDefault();

    const variantId = btn.getAttribute('data-upsell-variant');
    if (!variantId || btn.hasAttribute('disabled')) return;

    const originalLabel = btn.textContent;
    btn.setAttribute('disabled', '');
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('cart/add failed: ' + response.status);
      triggerCartRefresh();
    } catch (error) {
      console.error('Cart Upsell: failed to add product', error);
      btn.textContent = originalLabel;
      btn.removeAttribute('disabled');
    }
  });
})();